// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "static/js/" + chunkId + "." + {"239":"0a427976","453":"016b3b25","455":"ab6edc34","977":"2ae1c4ff"}[chunkId] + ".chunk.js";
};